export default __webpack_public_path__ + "media/images/features/local_delivery/external_icon-c8a49af58ff90fa2e68f6a50e41177dd.png";